// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"43790e63","542":"ed5e4cbb"}[chunkId] + ".chunk.js";
};